export * from './about/AboutPage';
export * from './contact/ContactPage';
export * from './error/ErrorPage';
export * from './home/HomePage';
export * from './services/ServicesPage';
export * from './portfolio/PortfolioPage';